module.exports = __webpack_public_path__ + "img/financial-profit_refund.8061e6c1.png";